import { ref, computed } from 'vue'
import { useFeaturesStore } from '@/shared/store/feature'
import { FEATURES } from '@/shared/constants/features.constants'

export const useFeatureToggle = () => {
  const featuresStore = useFeaturesStore()
  const isLoading = ref(false)
  const isReady = ref(false)

  const features = computed(() =>
    FEATURES.forEach((feature) => featuresStore.getFeatureValue(feature))
  )

  const initFeatureToggle = async () => {
    try {
      isLoading.value = true
      await featuresStore.fetchRemoteConfig()
    } catch (error) {
      console.error('Error initializing feature toggle:', error)
    } finally {
      isLoading.value = false
      isReady.value = true
    }
  }

  return {
    features,
    isLoading,
    isReady,
    initFeatureToggle,
  }
}
